// Ported from the portal's components/Icons/SubjectIcon.tsx (round subject image, portal default icon).
import DefaultIcon from "app/assets/portal/subjects/default.svg";
import STYLE_DEFAULTS from "app/scss/style";
import type { CSSProperties } from "react";
import styled from "styled-components";

const Styled = styled.img<{ $backgroundColor?: "primary" | "success" | "secondary" | "white" }>`
  border-radius: 50%;
  object-fit: cover;
  background-color: ${({ $backgroundColor }) => {
    if ($backgroundColor === "primary") return STYLE_DEFAULTS.MAIN_COLORS.primary;
    if ($backgroundColor === "success") return STYLE_DEFAULTS.MAIN_COLORS.success;
    if ($backgroundColor === "secondary") return STYLE_DEFAULTS.MAIN_COLORS.secondary;
    if ($backgroundColor === "white") return "rgba(255,255,255,0.18)";
    return "transparent";
  }};
`;

export default function SubjectIcon({ imageUrl, backgroundColor, name, ...rest }: { imageUrl?: string | null; name: string; style?: CSSProperties; className?: string; backgroundColor?: "primary" | "success" | "secondary" | "white" }) {
  return <Styled src={imageUrl || DefaultIcon} alt={name} loading="lazy" {...rest} $backgroundColor={backgroundColor} />;
}
